(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "2dfeb9dbb0450bdbf43da7f209d1b43c1f07c418"
};